// extracted by mini-css-extract-plugin
export var draftLockedContainer = "draft-locked-container_kIa1QRCjOcRAE8yI1PT0";